<template>
    <div class="root">
        <LazyImage :file="(user && user.photoURL) || ''"
                   :title="'Signed in as ' + ((user && user.displayName) || 'nobody')"
                   @click="details = user && !details"
                   class="profile-image"
                   size="32px"/>
        <AccountDetailsDialog @blur="details = false" v-if="details && user"/>
    </div>
</template>

<script>
    import 'firebase/firestore';
    import 'firebase/auth';
    import {listenForUser} from '../other/page-global';
    import LazyImage from './LazyImage';
    import Icon from './Icon';
    import UserSectionStat from './UserSectionStat';
    import AccountDetailsDialog from '../layouts/AccountDetailsDialog';

    export default {
        name: 'UserLayout',
        components: {AccountDetailsDialog, UserSectionStat, Icon, LazyImage},
        data() {
            return {
                details: false,
                user: null,
            };
        },
        methods: {
            userLoaded(user) {
                this.user = user;
            }
        },
        created() {
            this.listenerUnsub = listenForUser(this.userLoaded);
        },
        destroyed() {
            this.listenerUnsub();
        }
    };
</script>

<style scoped>
    .root {
        width: 36px;
        height: 36px;
        position: relative;
    }

    .profile-image {
        overflow: hidden;
        width: 36px;
        height: 36px;
        max-width: 36px;
        max-height: 36px;
        border-radius: 50%;
    }
</style>
